import * as React from 'react';
import {Grid as MuiGrid} from '@mui/material';

const Grid = (props: any) => {
    return <MuiGrid {...props} />
}

export default Grid;